<template>
    <div class="max-w-7xl mx-auto shadow-lg rounded-2xl overflow-hidden">
        <h2 class="text-2xl font-semibold p-4 border-b text-center">
            {{ t('affiliations.title') }}
        </h2>

        <!-- Table for medium+ screens -->
        <div class="hidden md:block overflow-x-auto">
            <table class="min-w-full border-collapse">
                <thead class="bg-gradient-to-r from-olve01 via-olve02 to-olve05 border-olve08">
                    <tr>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.number_abso') }}
                        </th>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.year_affiliation')
                        }}</th>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.name') }}</th>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.first_name') }}
                        </th>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.nationality') }}
                        </th>
                        <th class="px-4 py-2 text-left text-olve06 font-semibold">{{ t('affiliations.birth_date') }}
                        </th>
                        <th class="px-4 py-2 text-right text-olve06 font-semibold">{{ t('affiliations.age') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(affiliation, index) in affiliations" :key="index"
                        class="odd:bg-olve08 even:bg-gray-300 hover:bg-olve05 transition">
                        <td class="px-4 py-2 border-t">{{ affiliation['Numéro ABSO'] }}</td>
                        <td class="px-4 py-2 border-t">{{ affiliation["Année d'affiliations"] || '—' }}</td>
                        <td class="px-4 py-2 border-t">{{ affiliation['Nom'] || '—' }}</td>
                        <td class="px-4 py-2 border-t">{{ affiliation['Prénom'] || '—' }}</td>
                        <td class="px-4 py-2 border-t">{{ affiliation['Nationalité'] || '—' }}</td>
                        <td class="px-4 py-2 border-t">{{ affiliation['Date de naissance'] || '—' }}</td>
                        <td class="px-4 py-2 border-t text-right">{{ affiliation['Age'] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Card layout for small screens -->
        <div class="md:hidden space-y-4 p-4">
            <div v-for="(affiliation, index) in affiliations" :key="index"
                class="bg-gradient-to-r from-olve01/10 via-white to-olve02/10 rounded-xl shadow-md border border-olve03 p-5 hover:shadow-lg transition">

                <!-- Header -->
                <div class="flex justify-between items-center mb-3">
                    <h3 class="text-lg font-semibold text-olve01">
                        {{ affiliation['Nom'] || '—' }} {{ affiliation['Prénom'] || '' }}
                    </h3>
                    <span class="text-sm font-medium bg-olve05 text-white px-3 py-1 rounded-full">
                        {{ affiliation['Numéro ABSO'] }}
                    </span>
                </div>

                <!-- Details -->
                <div class="space-y-2 text-sm">
                    <p><span class="font-medium text-olve05">{{ t('affiliations.year_affiliation') }}:</span> {{
                        affiliation["Année d'affiliations"] || '—' }}</p>
                    <p><span class="font-medium text-olve05">{{ t('affiliations.nationality') }}:</span> {{
                        affiliation['Nationalité'] || '—' }}</p>
                    <p><span class="font-medium text-olve05">{{ t('affiliations.birth_date') }}:</span> {{
                        affiliation['Date de naissance'] || '—' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>



<script setup lang="ts">
import { ref, inject } from 'vue';
import { Composer } from 'vue-i18n';

// Inject the globally provided 't' function
const t = inject<Composer['t']>('t');
if (!t) {
    throw new Error('t is not provided')
}

import affiliationsData from '../data/historique_affiliations.json';

const affiliations = ref(affiliationsData);

</script>
